import classNames from 'classnames';
import * as React from 'react';

export type GlyphChipSize = 'sm' | 'md' | 'lg';
export type GlyphChipShape = 'square' | 'circle';

export interface GlyphChipProps extends React.HTMLAttributes<HTMLSpanElement> {
    size?: GlyphChipSize;
    shape?: GlyphChipShape;
}

const sizeClasses: Record<GlyphChipSize, string> = {
    sm: 'mp-glyph-chip--sm',
    md: 'mp-glyph-chip--md',
    lg: 'mp-glyph-chip--lg',
};

export const GlyphChip: React.FunctionComponent<GlyphChipProps> = ({size = 'md', shape = 'square', className, children, ...rest}: GlyphChipProps) => (
    <span className={classNames('mp-glyph-chip', sizeClasses[size], {'mp-glyph-chip--circle': shape === 'circle'}, className)} {...rest}>
        {children}
    </span>
);
